exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fa-lg[data-v-ed581ca2]{font-size:1.33333em !important;line-height:0.75em !important;vertical-align:-15% !important}.push-button[data-v-ed581ca2]{margin-bottom:25px}i[data-v-ed581ca2]{width:24px;height:24px;color:#3c59a5}button.el-button.el-button--default.el-button--medium[data-v-ed581ca2]{min-width:180px;height:36px;border-radius:4px;border:1px solid #3c59a5}.inputwidth[data-v-ed581ca2]{width:240px}.center[data-v-ed581ca2]{display:flex;justify-content:center;align-items:center}.plcz[data-v-ed581ca2]{width:140px;height:30px}.icon[data-v-ed581ca2]{margin-top:10px}\n", ""]);

// exports
